'use client'

export { ErrorPage as default } from '@/pages/error'
